import { render, staticRenderFns } from "./V3BtnGroup.vue?vue&type=template&id=239ce77d&scoped=true&"
import script from "./V3BtnGroup.vue?vue&type=script&lang=js&"
export * from "./V3BtnGroup.vue?vue&type=script&lang=js&"
import style0 from "./V3BtnGroup.vue?vue&type=style&index=0&id=239ce77d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239ce77d",
  null
  
)

export default component.exports